import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRetroCreditHeader',
})
export default class CmgRetroCreditHeader extends Vue {
  @Prop({ required: true, type: Number })
  step!: number;

  @Prop({ required: true, type: String })
  title!: string;
}
